(function ($, Drupal) {
  Drupal.behaviors.customScrollBehavior = {
    attach: function (context, settings) {
      const $isi = $('.isi', context);
      const $isiStart = $('#isi-start', context);
      const $isiToggle = $isi.find('.btn-toggle');
      const $isiToggleNav = $isi.find('.btn-toggle-nav');
      const $header = $('header', context);
      const $headerTop = $header.find('.header-top');
      const $headerMain = $header.find('.header-main');
      const $headerBottom = $header.find('.header-bottom');
      let headerHeight = $headerTop.outerHeight() + $headerMain.outerHeight() + $headerBottom.outerHeight();
      const offset = 5;
      const mm = matchMedia("(min-width: 992px)");

      mm.addEventListener('change', function (e) {
        headerHeight = $headerTop.outerHeight() + $headerMain.outerHeight() + $headerBottom.outerHeight();
      });

      $(window).on('load', function () {
        if (location.hash.length) {
          switch (location.hash) {
            case '#signup':
            case '#contact':
            case '#terms':
              $(location.hash).fadeIn();
              break;
            case '#isi':
              $isiToggle.click();
            default:
              if ($(location.hash).length) {
                setTimeout(function () {
                  $('html, body').animate({
                    scrollTop: $(location.hash).offset().top - headerHeight - offset
                  }, 500, 'linear');
                }, 500);
              }
          }
        }
        $('div img[src*="thrtle.com"]').attr('alt', '');
      });

      let position = 0;

      $isiToggle.on('click', e => {
        $root = $(e.currentTarget).closest('.isi');
        if ($root.is('.open')) {
          $('html, body').stop().animate({
            scrollTop: position
          }, 500, 'linear');
        } else {
          position = $(window).scrollTop()
          $('html, body').stop().animate({
            scrollTop: $isiStart.offset().top - headerHeight - offset
          }, 500, 'linear');
        }
      });

      $isiToggleNav.on('click', e => {
        position = $(window).scrollTop()
        $('html, body').stop().animate({
          scrollTop: $isiStart.offset().top - headerHeight - offset
        }, 500, 'linear');
      });
    }
  };
})(jQuery, Drupal);
